import { initialAvailabilitiesState } from './availabilities';
import { initialBookingsState } from './bookings';
import { initialFavouritesState } from './favourites';
import { initialMessagesState } from './messages';
import { initialNotificationState } from './notification';
import { initialOperatorsState } from './operators';
import { initialPaginationState } from './pagination';
import { initialServiceInfosState } from './service-infos';
import { initialServicesState } from './services';
import { initialTownsState } from './towns';
import { initialTripsState } from './trips';
import { initialUserDriverState } from './userDriver';
import { initialUserRegularState } from './userRegular';
import { initialUserState } from './users';
import { initialVehiclesState } from './vehicles';
import { initialBookingsSchedulerState } from './bookings-schedulers';

export const initialStates = {
  availabilities: initialAvailabilitiesState,
  bookings: initialBookingsState,
  favourites: initialFavouritesState,
  messages: initialMessagesState,
  notification: initialNotificationState,
  operators: initialOperatorsState,
  pagination: initialPaginationState,
  serviceInfos: initialServiceInfosState,
  services: initialServicesState,
  town: initialTownsState,
  trips: initialTripsState,
  userDriver: initialUserDriverState,
  userInfo: initialUserState,
  userRegular: initialUserRegularState,
  vehicles: initialVehiclesState,
  bookingsSchedulerState: initialBookingsSchedulerState
};
